import { createTypedValidator } from '@takeshape/json-schema';
export const shapeName = 'TSGenerateArgs';
export const schema = {
    type: 'object',
    properties: {
        input: {
            type: 'string',
            description: 'The generate message input from the user.'
        }
    },
    required: ['input'],
    additionalProperties: false
};
export const validate = createTypedValidator(schema);
